'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/object.assign/~/function-bind/index.js
// module id = 689
// module chunks = 0